import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import outerRouter from "./modules/outer";
const routes = [
  {
    path: "/",
    name: "Login",
    component: (r) =>
      require.ensure([], () => r(require("@/views/login/index"), "login")),
    meta: {
      title: "数字影像/报告查询",
    },
    hidden: true,
  },
  {
    path: "/checkInfo",
    name: "checkInfo",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/checkInfo/index"), "checkInfo")
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/filmQuery",
    name: "filmQuery",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/filmQuery/index"), "filmQuery")
      ),
    meta: {
      title: "医院数字影像查询系统",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/verifyPhone",
    name: "verifyPhone",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/filmQuery/verifyPhone"), "verifyPhone")
      ),
    meta: {
      title: "数字影像/手机号查询",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/findHospital",
    name: "findHospital",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/findHospital/index"), "findHospital")
      ),
    meta: {
      title: "查找医院",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/select",
    name: "selectPatient",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/selectPatient/index"), "selectPatient")
      ),
    meta: {
      title: "医院数字影像查询系统",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/reportList",
    name: "reportList",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/reportList/index"), "reportList")
      ),
    meta: {
      title: "全部检查",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/remoteList",
    name: "remoteList",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/remoteList/index"), "remoteList")
      ),
    meta: {
      title: "远程列表",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/print",
    component: (r) =>
      require.ensure([], () => r(require("@/views/stamp/index"), "print")),
    meta: {
      title: "检查报告单",
    },
    hidden: true,
  },
  {
    path: "/reportInfo",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/reportInfo/index"), "reportInfo")
      ),
    meta: {
      title: "医院数字影像查询系统",
      needLogin: true,
    },
    children: [
      {
        path: "report",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/report"), "reportInfo")
          ),
        meta: {
          title: "我的报告",
          needLogin: true,
        },
      },
      {
        path: "reportStemp",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/reportStemp"), "reportInfo")
          ),
        meta: {
          title: "我的报告",
          needLogin: true,
        },
      },
      {
        path: "portrait",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/portrait"), "reportInfo")
          ),
        meta: {
          title: "我的影像",
          needLogin: true,
        },
      },
      {
        path: "forwarding",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/forwarding"), "reportInfo")
          ),
        meta: {
          title: "转发报告",
          needLogin: true,
        },
      },
      {
        path: "attachment",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/attachment"), "attachment")
          ),
        meta: {
          title: "附件",
          needLogin: true,
        },
      },{
        path: "image",
        component: (r) =>
          require.ensure([], () =>
            r(require("@/views/reportInfo/children/image"), "Images")
          ),
        meta: {
          title: "附件",
          needLogin: true,
        },
      },
    ],
  },
  {
    path: "/reportUnfinished",
    name: "reportUnfinished",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/unfinished/index"), "reportUnfinished")
      ),
    meta: {
      title: "医院数字影像查询系统",
      needLogin: true,
    },
    hidden: true,
  },
  {
    path: "/healthImageDetail",
    name: "healthImageDetail",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/healthImageDetail/index"), "healthImageDetail")
      ),
    meta: {
      title: "详情",
    },
    hidden: true,
  },
  {
    path: "/500",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/error-page/500"), "error-page")
      ),
    meta: {
      title: "500",
    },
    hidden: true,
  },
  {
    path: "/404",
    component: (r) =>
      require.ensure([], () => r(require("@/views/error-page/404"), "404")),
    hidden: true,
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
  ...outerRouter,
];

const router = new VueRouter({
  mode: "hash",
  routes,
});
export default router;
